export const BUSINESS_ENTITY_TAX_CLASSIFICATION = Object.freeze({
  S_CORPORATION: 's_corporation',
  C_CORPORATION: 'c_corporation',
  PARTNERSHIP: 'partnership',
  SINGLE_MEMBER_LLC: 'single_member_llc'
});
